var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M6.25536 15.84C6.19107 15.84 6.13321 15.8271 6.06893 15.8014C5.88893 15.7307 5.77321 15.5571 5.77321 15.3579L5.7475 12.9343H3.16964C2.90607 12.9343 2.6875 12.7157 2.6875 12.4521V3.93429C2.6875 3.67072 2.90607 3.45215 3.16964 3.45215H14.8311C15.0946 3.45215 15.3132 3.67072 15.3132 3.93429V12.4586C15.3132 12.7221 15.0946 12.9407 14.8311 12.9407H9.3925L6.59607 15.6986C6.50607 15.7886 6.38393 15.84 6.25536 15.84ZM3.65179 11.9764H6.22321C6.48679 11.9764 6.70536 12.1886 6.70536 12.4521L6.72464 14.2136L8.8525 12.1114C8.9425 12.0214 9.06464 11.97 9.19321 11.97H14.3489V4.41643H3.65179V11.9764Z",
          fill: "#676060",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }